// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import emailjs from "emailjs-com";
// import "./membership.css";

// const Membership = () => {
//   const navigate = useNavigate();
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     contribution: "",
//     address: "",
//   });
//   const [showSuccessMessage, setShowSuccessMessage] = useState(false);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     const templateParams = {
//       to_name: "E-TECHNO",
//       from_name: formData.name,
//       email: formData.email,
//       phone: formData.phone,
//       contribution: formData.contribution,
//       address: formData.address,
//     };

//     emailjs
//       .send(
//         "service_s3k5vcw", 
//         "template_bn59add", 
//         templateParams,
//         "9ZRaTReespHp7TbQz"
//       )
//       .then(
//         () => {
//           setShowSuccessMessage(true);
//           setTimeout(() => {
//             navigate("/");
//           }, 4000);
//         },
//         () => {
//           alert("Failed to submit application. Please try again.");
//         }
//       );
//   };

//   return (
//     <div className="contact-form-container">
//       {showSuccessMessage && (
//         <div className="success-message">
//           Thank you for becoming a member! You'll be redirected shortly.
//         </div>
//       )}

//       <header className="contact-form-header">
//         <h1>Membership Application</h1>
//         <p>We're excited to learn about your passion!</p>
//       </header>

//       <form className="contact-form-section" onSubmit={handleSubmit}>
//         <div className="contact-form-group">
//           <label htmlFor="name">Full Name</label>
//           <input
//             type="text"
//             id="name"
//             name="name"
//             value={formData.name}
//             onChange={handleChange}
//             required
//             placeholder="Enter your full name"
//           />
//         </div>

//         <div className="contact-form-row">
//           <div className="contact-form-group">
//             <label htmlFor="email">Email ID</label>
//             <input
//               type="email"
//               id="email"
//               name="email"
//               value={formData.email}
//               onChange={handleChange}
//               required
//               placeholder="Enter your email"
//             />
//           </div>

//           <div className="contact-form-group">
//             <label htmlFor="phone">Phone Number</label>
//             <input
//               type="tel"
//               id="phone"
//               name="phone"
//               value={formData.phone}
//               onChange={handleChange}
//               required
//               placeholder="+91"
//             />
//           </div>
//         </div>

//         <div className="contact-form-group">
//           <label htmlFor="contribution">Why Do You Want to Join Us?</label>
//           <textarea
//             id="contribution"
//             name="contribution"
//             value={formData.contribution}
//             onChange={handleChange}
//             required
//             placeholder="Share your motivation, vision, and how you wish to contribute to our mission"
//           ></textarea>
//         </div>

//         <div className="contact-form-group">
//           <label htmlFor="address">Address</label>
//           <textarea
//             id="address"
//             name="address"
//             value={formData.address}
//             onChange={handleChange}
//             required
//             placeholder="Enter your current address"
//           ></textarea>
//         </div>

//         <button type="submit" className="contact-form-submit">Submit Application</button>
//       </form>

//       <footer className="contact-form-footer">
//         <p>&copy; 2024 E-Techno Educational and Research Society. All rights reserved.</p>
//       </footer>
//     </div>
//   );
// };

// export default Membership;

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import emailjs from "emailjs-com";
import "./membership.css";

const Membership = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    contribution: "",
    address: "",
  });
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const nameParts = formData.name.trim().split(" ");
    const firstName = nameParts[0] || "";
    const lastName = nameParts.slice(1).join(" ") || "";

    const templateParams = {
      to_name: "E-TECHNO",
      firstName: firstName,
      lastName: lastName,
      subject: "Membership Application",
      message: formData.contribution, 
      email: formData.email,
      phone: formData.phone,
      contribution: formData.contribution, // Explicitly pass contribution
      address: formData.address,
    };

    emailjs
      .send(
        "service_s3k5vcw", 
        "template_bn59add", 
        templateParams,
        "9ZRaTReespHp7TbQz"
      )
      .then(
        () => {
          setShowSuccessMessage(true);
          setTimeout(() => {
            navigate("/");
          }, 4000);
        },
        () => {
          alert("Failed to submit application. Please try again.");
        }
      );
  };

  return (
    <div className="contact-form-container">
      {showSuccessMessage && (
        <div className="success-message">
          Thank you for becoming a member! You'll be redirected shortly.
        </div>
      )}

      <header className="contact-form-header">
        <h1>Membership Application</h1>
        <p>We're excited to learn about your passion!</p>
      </header>

      <form className="contact-form-section" onSubmit={handleSubmit}>
        <div className="contact-form-group">
          <label htmlFor="name">Full Name</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
            placeholder="Enter your full name"
          />
        </div>

        <div className="contact-form-row">
          <div className="contact-form-group">
            <label htmlFor="email">Email ID</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="Enter your email"
            />
          </div>

          <div className="contact-form-group">
            <label htmlFor="phone">Phone Number</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              required
              placeholder="+91"
            />
          </div>
        </div>

        <div className="contact-form-group">
          <label htmlFor="contribution">Why Do You Want to Join Us?</label>
          <textarea
            id="contribution"
            name="contribution"
            value={formData.contribution}
            onChange={handleChange}
            required
            placeholder="Share your motivation, vision, and how you wish to contribute to our mission"
          ></textarea>
        </div>

        <div className="contact-form-group">
          <label htmlFor="address">Address</label>
          <textarea
            id="address"
            name="address"
            value={formData.address}
            onChange={handleChange}
            required
            placeholder="Enter your current address"
          ></textarea>
        </div>

        <button type="submit" className="contact-form-submit">Submit Application</button>
      </form>

      <footer className="contact-form-footer">
        <p>&copy; 2024 E-Techno Educational and Research Society. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default Membership;

